// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Es6Promise from 'es6-promise'
import 'es6-promise/auto'
import Vue from 'vue'
import App from './App'
import router from './router'
import moment from 'moment'
import Notifications from 'vue-notification'
import { store } from './store/store'
import Icon from './icon.vue'
import autogrow from './directives/autogrow'
Es6Promise.polyfill()

Vue.component('icon', Icon)
Vue.directive('autogrow', autogrow)

// Moment
window['moment'] = moment
moment.locale('da')

// Vue.use
Vue.use(Notifications)

// Filters
Vue.prototype.$filters = Vue.options.filters // So we can acces the filters in js

Vue.filter('formatDateTime', function (date) {
    if (date) {
        return window['moment'].utc(date).local().format('DD[.] MMMM YYYY[,] [kl.] HH[:]mm')
    } else {
        return null
    }
})

Vue.filter('formatDateTimeShort', function (date) {
    if (date) {
        return window['moment'].utc(date).local().format('DD[.] MMM[.] YYYY[,] HH[:]mm')
    } else {
        return null
    }
})

Vue.filter('formatDateTimeElapsed', function (date) {
    if (date) {
        if (date === 'Ingen dato') {
            return date
        } else {
            let now = moment(new Date())
            let yesterday = moment().subtract(1, 'day')
            let dayBeforeYesterday = moment().subtract(2, 'day')
            let tomorrow = moment().add(1, 'day')
            let dayAfterTomorrow = moment().add(2, 'day')

            if (moment(date).isSame(now, 'day')) {
                return 'I dag ' + window['moment'].utc(date).local().format('[kl.] HH[:]mm')
            } else if (moment(date).isSame(yesterday, 'day')) {
                return 'I går ' + window['moment'].utc(date).local().format('[kl.] HH[:]mm')
            } else if (moment(date).isSame(dayBeforeYesterday, 'day')) {
                return 'I forgårs ' + window['moment'].utc(date).local().format('[kl.] HH[:]mm')
            } else if (moment(date).isSame(tomorrow, 'day')) {
                return 'I morgen ' + window['moment'].utc(date).local().format('[kl.] HH[:]mm')
            } else if (moment(date).isSame(dayAfterTomorrow, 'day')) {
                return 'I overmorgen ' + window['moment'].utc(date).local().format('[kl.] HH[:]mm')
            } else if (moment(date).isSame(now, 'week')) {
                if (moment(date).isBefore(now, 'day')) {
                    return 'I ' + window['moment'].utc(date).local().format('dddd[s] [kl.] HH[:]mm')
                } else if (moment(date).isAfter(now, 'day')) {
                    return 'På ' + window['moment'].utc(date).local().format('dddd [kl.] HH[:]mm')
                }
            } else {
                return window['moment'].utc(date).local().format('DD[.] MMMM YYYY[,] [kl.] HH[:]mm')
            }
        }
    } else {
        return 'Ingen dato'
    }
})

Vue.filter('formatDate', function (date) {
    if (date) {
        return window['moment'].utc(date).local().format('DD[.] MMMM YYYY')
    } else {
        return null
    }
})

Vue.filter('formatDateShort', function (date) {
    if (date) {
        if (window['moment'].utc(date).local().format('M') === '5') {
            return window['moment'].utc(date).local().format('DD[.] MMM YYYY')
        } else {
            return window['moment'].utc(date).local().format('DD[.] MMM[.] YYYY')
        }
    } else {
        return null
    }
})

Vue.filter('formatDateShortElapsed', function (date) {
    if (date) {
        if (date === 'Ingen dato') {
            return date
        } else {
            let now = moment(new Date())
            let yesterday = moment().subtract(1, 'day')
            let dayBeforeYesterday = moment().subtract(2, 'day')
            let tomorrow = moment().add(1, 'day')
            let dayAfterTomorrow = moment().add(2, 'day')

            if (moment(date).isSame(now, 'day')) {
                return 'I dag'
            } else if (moment(date).isSame(yesterday, 'day')) {
                return 'I går'
            } else if (moment(date).isSame(dayBeforeYesterday, 'day')) {
                return 'I forgårs'
            } else if (moment(date).isSame(tomorrow, 'day')) {
                return 'I morgen'
            } else if (moment(date).isSame(dayAfterTomorrow, 'day')) {
                return 'I overmorgen'
            } else if (moment(date).isSame(now, 'week')) {
                if (moment(date).isBefore(now, 'day')) {
                    return 'I ' + window['moment'].utc(date).local().format('dddd[s]')
                } else if (moment(date).isAfter(now, 'day')) {
                    return 'På ' + window['moment'].utc(date).local().format('dddd')
                }
            } else {
                if (window['moment'].utc(date).local().format('M') === '5') {
                    return window['moment'].utc(date).local().format('DD[.] MMM YYYY')
                } else {
                    return window['moment'].utc(date).local().format('DD[.] MMM[.] YYYY')
                }
            }
        }
    } else {
        return 'Ingen dato'
    }
})

Vue.filter('formatTime', function (time) {
    if (time) {
        return window['moment'].utc(time).local().format('[kl.] HH[:]mm')
    } else {
        return null
    }
})

Vue.filter('formatTimeShort', function (time) {
    if (time) {
        return window['moment'].utc(time).local().format('HH[:]mm')
    } else {
        return null
    }
})

Vue.filter('toLowerCase', function (string) {
    return string.toLowerCase()
})
Vue.filter('tabsToDanish', function (text) {
    text = text.toString()
    if (text === 'requests') {
        return 'Henvendelser'
    }
    if (text === 'tasks') {
        return 'Opgaver'
    }
    if (text === 'requisitions') {
        return 'Entreprenøropgaver'
    }
    if (text === 'routines') {
        return 'Rutiner'
    }
    if (text === 'templates') {
        return 'Skabeloner'
    }
})
Vue.filter('supplyAbbreviation', function (string) {
    let description = ''
    switch (string.toLowerCase()) {
    case 'rensningsanlæg':
        description = 'Rens.'
        return description
    case 'administration':
        description = 'Admin.'
        return description
    }
    return string.toLowerCase()
})

Vue.filter('operatorAsPlainText', function (operator) {
    const operatorList = {
        IsLessThan: 'er mindre end',
        IsLessThanOrEqualTo: 'er mindre end eller lig med',
        IsEqualTo: 'er lig med',
        IsNotEqualTo: 'er ikke lig med',
        IsGreaterThan: 'er større end',
        IsGreaterThanOrEqualTo: 'er større end eller lig med',
        IsLike: 'indeholder',
        IsNotLike: 'indeholder ikke',
        StartsWith: 'starter med',
        NotStartsWith: 'starter ikke med',
        EndsWith: 'ender med',
        NotEndsWith: 'ender ikke med',
        IsNull: 'er ´null´',
        IsNil: 'er ´nil´'
    }

    return operatorList[operator]
})

Vue.config.productionTip = false

/* eslint-disable no-new */
const app = new Vue({
    el: '#app',
    store,
    router,
    template: '<App/>',
    components: {
        App
    }
})

router.beforeEach((to, from, next) => {
    app.$store.commit('setRouterHistory', from.name)
    next()
})



// WEBPACK FOOTER //
// ./src/main.js